export default __webpack_public_path__ + "/dist/images/Banner-img.d784cb548c45a8432b2ecfd7541e5d41.png";